export type TitleType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'display' | 'subdisplay';
export type Corner = 'rounded-none' | 'rounded-sm' | 'rounded-md' | 'rounded-lg' | 'rounded-xl' | 'rounded-2xl' | 'rounded-full';
export type Fit = 'cover' | 'contain' | 'fill' | 'none';
export type Shadow = 'shadow' | 'shadow-md' | 'shadow-lg' | 'shadow-xl' | 'shadow-2xl' | 'shadow-inner' | 'shadow-none';
export type ButtonVariant = "primary" | "secondary" | "success" | "alert" | "info" | "primary-outline" | "secondary-outline" | "success-outline" | "alert-outline" | "info-outline" | "text" | "null";

export const getColorStatutLivraison = (statut: string) => {
	switch (statut) {
		case "LIVREE":
			return "bg-green-200";
		case "PLANIFIEE":
			return "bg-primary-200";
		case "EN_ATTENTE":
			return "bg-gray-200";
	}
	return "bg-blue-200"
}

export const getStatutLivraison = (statut: string) => {
	switch (statut) {
		case "LIVREE":
			return "Livrée";
		case "PLANIFIEE":
			return "Planifiée";
		case "EN_ATTENTE":
			return "En attente";
	}
	return "A définir"
}

export const filtersStatutLivraison = () => {
	return [
		{ label: 'Livrée', value: 'LIVREE' },
		{ label: 'Planifiée', value: 'PLANIFIEE' },
		{ label: 'En attente', value: 'EN_ATTENTE' },
	]
}

export const getColorStatutPanier = (statut: string) => {
	switch (statut) {
		case "BROUILLON":
			return "bg-blue-200";
		case "PAYE":
			return "bg-green-200";
		case "PAIEMENT_REFUSE":
			return "bg-red-200";
	}
}

export const getStatutPanier = (statut: string) => {
	switch (statut) {
		case "BROUILLON":
			return "Brouillon";
		case "PAYE":
			return "Payé";
		case "PAIEMENT_REFUSE":
			return "Paiement refusé";
	}
}

export const filtersStatutPanier = () => {
	return [
		{ label: 'Brouillon', value: 'brouillon' },
		{ label: 'Payé', value: 'paye' },
		{ label: 'Paiement refusé', value: 'paiement_refuse' },
	]
}

export const formatDate = (date: string) => {
	return new Date(date).toLocaleDateString('fr-FR', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	});
}

export function validatePassword(password: string): string | null {
	const hasUpperCase = /[A-Z]/.test(password);
	const hasLowerCase = /[a-z]/.test(password);
	const hasMinLength = password.length >= 8;

	if (!hasMinLength)
		return "Le mot de passe doit contenir au moins 8 caractères";
	if (!hasUpperCase)
		return "Le mot de passe doit contenir au moins une majuscule";
	if (!hasLowerCase)
		return "Le mot de passe doit contenir au moins une minuscule";
	return null;
}

export const PASSWORD_REQUIREMENT = "Le mot de passe doit faire au moins 8 caractères et contenir au moins une majuscule et une minuscule."